import React from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Alert,
  Tabs,
  Tab,
  Paper,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";
import ConfirmationModal from "../../../../../components/Modal/ConfirmationModal";
import { ActiveFlowsList } from "./ActiveFlowsList";
import { useFlowsManagerView } from "./useFlowsManagerView";

export const FlowsManagerView: React.FC = () => {
  const {
    filter,
    filteredFlows,
    flowsLoading,
    error,
    clearError,
    counts,
    deleteDialogOpen,
    deleteLoading,
    handleFilterChange,
    handleCreateNew,
    handleEdit,
    handleDeleteClick,
    handleDeleteConfirm,
    handleDeleteCancel,
    handleToggleStatus,
    handleDuplicate,
    handleBackToMenu,
  } = useFlowsManagerView();

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      {/* Header */}
      <Box sx={{ display: "flex", alignItems: "center", mb: 2, gap: 2 }}>
        <IconButton onClick={handleBackToMenu} size="small">
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h6">Flows Manager</Typography>
        <Box sx={{ flex: 1 }} />
        <Button variant="contained" startIcon={<AddIcon />} onClick={handleCreateNew}>
          Create Flow
        </Button>
      </Box>

      {error && (
        <Alert severity="error" onClose={clearError} sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {/* Filter Tabs */}
      <Paper sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={filter} onChange={handleFilterChange}>
            <Tab value="all" label={`All (${counts.all})`} />
            <Tab value="active" label={`Active (${counts.active})`} />
            <Tab value="inactive" label={`Inactive (${counts.inactive})`} />
            <Tab value="draft" label={`Draft (${counts.draft})`} />
          </Tabs>
        </Box>

        <Box sx={{ flex: 1, overflow: "auto", p: 2 }}>
          <ActiveFlowsList
            flows={filteredFlows}
            loading={flowsLoading}
            onEdit={handleEdit}
            onDelete={handleDeleteClick}
            onDuplicate={handleDuplicate}
            onToggleStatus={handleToggleStatus}
          />
        </Box>
      </Paper>

      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        open={deleteDialogOpen}
        title="Delete Flow"
        message="Are you sure you want to delete this flow? This action cannot be undone."
        confirmText="Delete"
        cancelText="Cancel"
        onConfirm={handleDeleteConfirm}
        onCancel={handleDeleteCancel}
        severity="error"
        submitLoading={deleteLoading}
      />
    </Box>
  );
};
